/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardHistoryTopThreeEntry
 */
export interface LeaderboardHistoryTopThreeEntry {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryTopThreeEntry
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardHistoryTopThreeEntry
     */
    displayName: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryTopThreeEntry
     */
    finalValue: number;
    /**
     * What this finisher was paid, as the snapshot recorded it. Per period only — never a running total across boards. Absent when the place was not paid.
     * @type {string}
     * @memberof LeaderboardHistoryTopThreeEntry
     */
    prizeSummary?: string;
}

/**
 * Check if a given object implements the LeaderboardHistoryTopThreeEntry interface.
 */
export function instanceOfLeaderboardHistoryTopThreeEntry(value: object): value is LeaderboardHistoryTopThreeEntry {
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('finalValue' in value) || value['finalValue'] === undefined) return false;
    return true;
}

export function LeaderboardHistoryTopThreeEntryFromJSON(json: any): LeaderboardHistoryTopThreeEntry {
    return LeaderboardHistoryTopThreeEntryFromJSONTyped(json, false);
}

export function LeaderboardHistoryTopThreeEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardHistoryTopThreeEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'displayName': json['displayName'],
        'finalValue': json['finalValue'],
        'prizeSummary': json['prizeSummary'] == null ? undefined : json['prizeSummary'],
    };
}

export function LeaderboardHistoryTopThreeEntryToJSON(json: any): LeaderboardHistoryTopThreeEntry {
    return LeaderboardHistoryTopThreeEntryToJSONTyped(json, false);
}

export function LeaderboardHistoryTopThreeEntryToJSONTyped(value?: LeaderboardHistoryTopThreeEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'displayName': value['displayName'],
        'finalValue': value['finalValue'],
        'prizeSummary': value['prizeSummary'],
    };
}

